<div class="shell">
  <app-main-menu [title]="title()"></app-main-menu>
  <div class="shell__content">
    @if (authService.sessionExpired()) {
      <section class="session-banner" aria-live="polite">
        <p class="session-banner__eyebrow">{{ i18n.t('app.sessionExpired.eyebrow') }}</p>
        <div class="session-banner__body">
          <div>
            <h2>{{ i18n.t('app.sessionExpired.title') }}</h2>
            <p>{{ i18n.t('app.sessionExpired.prompt') }}</p>
          </div>
          <div class="session-banner__actions">
            <button mat-stroked-button type="button" (click)="authService.login('google')">
              {{ i18n.t('mainMenu.signInWithGoogle') }}
            </button>
            <button mat-flat-button type="button" (click)="authService.login('office365')">
              {{ i18n.t('mainMenu.signInWithMicrosoft') }}
            </button>
          </div>
        </div>
      </section>
    }

    @if (!authService.currentUserResolved()) {
      <section class="hero">
        <div>
          <p class="hero__eyebrow">{{ i18n.t('app.unauthenticated.eyebrow') }}</p>
          <h1>{{ i18n.t('app.title') }}</h1>
          <p class="hero__copy">{{ i18n.t('home.companies.loading') }}</p>
        </div>
      </section>
    } @else if (authService.shouldShowProtectedContent()) {
      <router-outlet></router-outlet>
    } @else {
      <section class="hero">
        <div>
          <p class="hero__eyebrow">{{ i18n.t('app.unauthenticated.eyebrow') }}</p>
          <h1>{{ i18n.t('app.title') }}</h1>
          <p class="hero__copy">
            {{ i18n.t('app.unauthenticated.prompt') }}
          </p>
        </div>
      </section>
    }
  </div>

  @if (authService.currentUserResolved() && authService.isAuthenticated()) {
    @defer (on idle) {
      <div appRouterMarkdownLinks>
        <lib-clippy-chat></lib-clippy-chat>
      </div>
    }
  }
</div>
